import React from 'react';

interface ProductSubmitButtonProps {
  formId?: number;
  isSubmitting?: boolean;
  itemTypeCode?: number;
  onClick: () => void; // ← nuevo
}

const ProductSubmitButton: React.FC<ProductSubmitButtonProps> = ({
  formId,
  isSubmitting = false,
  itemTypeCode,
  onClick,
}) => {
  const isEdit = !!formId;

  const getLabel = () => {
    if (itemTypeCode === 1) return isEdit ? 'Actualizar Producto' : 'Registrar Producto';
    if (itemTypeCode === 2) return isEdit ? 'Actualizar Servicio' : 'Registrar Servicio';
    return isEdit ? 'Actualizar Ítem' : 'Registrar Ítem';
  };

  return (
    <div>
      <button
        type="button"
        disabled={isSubmitting}
        onClick={onClick} // ← usamos la prop aquí
        className="mt-6 flex w-full items-center justify-center gap-2 rounded bg-primary px-4.5 py-2.5 font-medium text-white hover:bg-opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
      >
        {getLabel()}
      </button>
    </div>
  );
};

export default ProductSubmitButton;
